import { useEffect, useState } from "react";
import { Table } from "@mantine/core";
import { useDispatch, useSelector } from "react-redux";
import { getUsersList, updateProfileActivate, updateProfileDectivate } from "../../store/actions";
import { manageusers_column } from "../../helpers/columns";
import { MantineGrid, MantineGridColumn } from "../../components/mantine/grid";
import { useDisclosure } from "@mantine/hooks";
import { MantineModal } from "../../components/mantine/modal";
import { RolejobColors } from "../../helpers/constant";
import { getClientdropdown, fetchAllRole } from "../../store/actions";
import { PlaceholderUi, useCustomMediaQuery } from "../../helpers/common";
import { useStateContext } from "../../Contexts/ContextProvider";
import MantineContainer from "../../components/mantine/container";
import UserForm from "./UserForm";
import MantineTextInput from "../../components/mantine/textinput";
import MantineButton from "../../components/mantine/button";
import MantinePagination from "../../components/mantine/pagination";
import MantineGroup from "../../components/mantine/group";
import ConfirmationPopup from "../../components/common/confirmationPopUp";
import moment from "moment";
import ResetPasswordForm from "./resetPassword";
import DeleteConfirmation from "./delete";
// import { shuffleArray } from "@/helpers/common";
import MantineCloseButton from "../../components/mantine/closeButton";
import ActionMenu from './Components/ActionMenu';
import CustomModalHeaderTitle from "../../components/common/customModalHeaderTitle";
import AvatarComponent from "./Components/AvatarComponent";
import BadgeComponent from "./Components/BadgeComponent";
import StatusComponent from '../../pages/manageuser/Components/StatusComponents';
import TitleComponent from "../../components/common/title";
import { useDebounce } from "../../utlis/debounceHook";
//import  MantineSwitch  from '../../components/mantine/button';
export default function ManageUserProfile(props: any) {
    const dispatch = useDispatch();

    const [searchValue, setSearchValue] = useState<any>('');
    const [pageSize, setPageSize] = useState<any>(5);
    const [pageNumber, setPageNumber] = useState<any>(1);
    const [activepageNumber, setActivePageNumber] = useState<any>(1);
    const [selectedRows, SetSelectedRows] = useState<any>([])
    const [opened, { open, close }] = useDisclosure(false); // modal open close functionality
    const [openedConfirmationPopup, { open: openConfirmationPopup, close: closeConfirmationPopup }] = useDisclosure(false); // modal open close functionality
    const [openedResetPassword, { open: openResetPassword, close: closeResetPassword }] = useDisclosure(false);
    const [OpenedDeletePopUp, { open: OpendeletePopUp, close: closeDeletePopUp }] = useDisclosure(false);
    const { currentPrimaryColor, currentSecondaryColor, currentTeritorryColor } = useStateContext();
    
    const { isLargeScreenmin, isSmallScreen } = useCustomMediaQuery();
    const [passwordVal, setpasswordVal] = useState(false)
    const debouncedQuery = useDebounce(searchValue, 500);

    const { getUser, Count,getrole, getClient} = useSelector((state: any) => ({
        getUser: state?.getuserData?.userlist,
        Count: state?.getuserData?.totalCount,
        getrole: state?.getuserData?.getrole,
        getClient: state?.getclientData?.clientdropdown,
    }));

    useEffect(() => {
        getList();
    }, [pageNumber, pageSize, debouncedQuery])

    useEffect(() => {
        if (searchValue?.length == 0) {
            const data = {
                "pageNumber": activepageNumber,
                "pageSize": pageSize,
                "sortColumn": "",
                "sortDirection": "",
                "searchKeyword": searchValue
            }
            dispatch(getUsersList(data))
        }
    }, [searchValue])

    const getList = () => {
        const data = {
            "pageNumber": pageNumber,
            "pageSize": pageSize,
            "sortColumn": "",
            "sortDirection": "",
            "searchKeyword": searchValue
        }
        dispatch(getUsersList(data))
    }
    const ClientLists = () => {
        const data = {
          "pageNumber": "1",
          "pageSize": "1000",
          "sortColumn": "",
          "sortDirection": "",
          "searchKeyword": searchValue
        };  
        
        dispatch(getClientdropdown(data)); 
      };
      
    useEffect(() => {
        ClientLists();
    }, [])
    
    const roleNames = getrole?.map((role: any) => ({ value: String(role.id), label: role.roleName }));
    useEffect(() => {
        dispatch(fetchAllRole())
    }, [])


    const handleResponseUserForm = (status: any) => {
        if (status === "SUCCESS" || status === "ADD SUCCESS") {
            close();
            getList();
        }
        if (opened) {
            close(); 
        } else {
            open();  
        }
    }

    // Activate and Deactivate account function
    const onActivationDeactivation = () => {
        openConfirmationPopup();
    }
    const handleResponseActivateDeactivate = (status: any) => {
        if (status == "DeActivate Success" || status == "Activate Success") {
            getList();
            closeConfirmationPopup();
        }

          else openedConfirmationPopup ? closeConfirmationPopup() : openConfirmationPopup();
    }

    
    const confirmationPopup = (selectedRows: any) => {
        if (selectedRows?.isActive) dispatch(updateProfileDectivate(selectedRows?.id, handleResponseActivateDeactivate));
        else dispatch(updateProfileActivate(selectedRows?.id, handleResponseActivateDeactivate));
    }

    const handleResponsepassword = (status: any) => {
        if (status === "SUCCESS"){ 
            closeResetPassword();
             setpasswordVal(false);
        }
        else openedResetPassword ? closeResetPassword() : openResetPassword();
    }
    
    const handleDelete = () => {
        closeDeletePopUp();
        getList();
    }

    const getuserReport = (reports: any) => {
        const clientData: any = {
            "sortColumn": "",
            "sortDirection": "",
            "searchKeyword": searchValue,
            isExport: true
        };
    
        if (!reports) {
            clientData.pageNumber = pageNumber;
            clientData.pageSize = pageSize;
        }
    
        if (reports == true) {
            dispatch(getUsersList(clientData, "export", `${moment(Date()).format('YYYY_MM_DD')}_user_list`));
        }
    }   
    const handlePageSizeChange = (value: string) => {
        setPageSize(Number(value));
        setPageNumber(1);
    };

    const handleCloseValue = () => {
        setSearchValue('');
    }

    const rows = getUser?.map((item: any, index: any) => (
        <Table.Tr key={item.id}>
            {/* <Table.Td data-label="Employee">
                <AvatarComponent item={item} currentPrimaryColor={currentPrimaryColor} />
            </Table.Td> */}
            <Table.Td data-label="Customer ID">{item.userName}</Table.Td>
            <Table.Td data-label="Email">{item.email}</Table.Td>
            <Table.Td data-label="Client Name">{item.clientName}</Table.Td>
            <Table.Td data-label="Status">
                <StatusComponent item={item} />
            </Table.Td>
            <Table.Td data-label="User Role">{item.roleName}</Table.Td>
            <Table.Td data-label="Action">
                <ActionMenu
                    item={item}
                    open={open}
                    OpendeletePopUp={OpendeletePopUp}
                    openResetPassword={openResetPassword}
                    onActivationDeactivation={onActivationDeactivation}
                    SetSelectedRows={SetSelectedRows}
                />
            </Table.Td>
        </Table.Tr>
    ));

    const clientNames = getClient?.map((client: any) => ({ value: String(client.id), label: client.name }));

    const classButton = `w-fit text-sm font-thin ${isSmallScreen && 'w-full'}`  // multiple time css call so single line convert
    return (
        <div className="w-full mt-4">
            <TitleComponent title="Manage Users" />
            <MantineContainer fluid={true} className="m-auto bg-white my-6 px-5">
                <MantineGrid className="py-5" grow={true}>
                    <MantineGridColumn span={{ base: 12, md: 3, lg: 3 }} >
                        <form onSubmit={(event: any) => { event.preventDefault(); setPageNumber(1); getList() }}>
                            <MantineTextInput
                                placeholder={`Search by Customer ID or Email`}
                                onChange={(event: any) => { setSearchValue(event.currentTarget?.value) }}
                                value={searchValue}
                                rightSection={searchValue?.length >= 1 && <MantineCloseButton onClick={() => handleCloseValue()} />}
                                classNames={{ input: `${PlaceholderUi}` }}
                            />
                        </form>
                    </MantineGridColumn>
                    <MantineGridColumn span={{ base: 12, md: 3, lg: 3 }}>
                        <MantineButton
                            name={'Search'}
                            color={currentPrimaryColor}
                            className={classButton}
                            onClick={() => { getList() }}
                        />

                    </MantineGridColumn>
                    <MantineGridColumn span={{ base: 12, md: 6, lg: 6 }}>
                        <MantineGroup justify="flex-end">
                            <MantineButton
                                name={'+ Add New User'}
                                className={classButton}
                                color={currentPrimaryColor}
                                onClick={() => { open(); SetSelectedRows([]) }}
                            />
                            <MantineButton
                                name={'Export'}
                                color={currentPrimaryColor}
                                onClick={() => getuserReport(true)}
                                className={classButton}
                            />
                        </MantineGroup>
                    </MantineGridColumn>
                </MantineGrid>
            </MantineContainer>
            <MantineContainer fluid={true} className="m-auto bg-white pt-5 px-5 pb-10">
                <div className={`${rows?.length !== 0 && 'mobile-responsive-scroll'}`}>
                    <Table className="bg-global_bg" verticalSpacing="sm">
                        <Table.Thead>
                            <Table.Tr>
                                {manageusers_column?.map((data: any) => {
                                    return <Table.Th key={data.id}>{data.name}</Table.Th>;
                                })}
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody className="relative">{rows?.length == 0 ? <div className={`${isLargeScreenmin ? `mt-4 absolute left-1/2 text-center` : 'text-center'}`}>No Data Found</div> : rows}</Table.Tbody>
                    </Table>
                </div>
                <MantineGroup className={`justify-end pt-5 ${rows?.length == 0 && isLargeScreenmin && 'pb-8'}`}>
                    {rows?.length != 0 &&
                        <MantinePagination
                            total={Math.ceil(Count / pageSize)}
                            onChange={(value: any) => { setPageNumber(value); setActivePageNumber(value) }}
                            
                            color={currentPrimaryColor}
                            withEdges={true}
                            valueSelect={pageSize}
                            size={"md"}
                            className='m-auto pb-4'
                            onChangeSelect={handlePageSizeChange}
                            value={searchValue?.length != 0 ? pageNumber : activepageNumber}
                        />
                    }
                </MantineGroup>
                <MantineModal size={"xl"} opened={opened} onClose={close} title={<CustomModalHeaderTitle title={`${selectedRows?.length == 0 ? "Add" : "Edit"} User`} onClick={close} />}>
                    <UserForm userData={selectedRows} handleResponseUserForm={handleResponseUserForm} modalclose={close} dispatch={dispatch} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor} passwordVal={passwordVal} setpasswordVal={setpasswordVal} clientNames={clientNames} roleNames={roleNames} />
                </MantineModal>
                <ConfirmationPopup size={"md"} onClose={closeConfirmationPopup} handleConfirm={() => confirmationPopup(selectedRows)} opened={openedConfirmationPopup} ModalBodyMessage={`Are you sure you want to ${!selectedRows?.isActive ? 'Activation' : "De-Activation"} ?`} />
                <MantineModal opened={openedResetPassword} onClose={closeResetPassword} title={<CustomModalHeaderTitle title='Reset Password' onClick={closeResetPassword} />}>
                    <ResetPasswordForm userData={selectedRows} modalclose={closeResetPassword} dispatch={dispatch} handleResponsepassword={handleResponsepassword} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor}
                        passwordVal={passwordVal} setpasswordVal={setpasswordVal}
                    />
                </MantineModal>
                <MantineModal opened={OpenedDeletePopUp} onClose={closeDeletePopUp} title={<CustomModalHeaderTitle title='Delete' onClick={closeDeletePopUp} />}>
                    <DeleteConfirmation userData={selectedRows} modalclose={closeDeletePopUp} handleDelete={handleDelete} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor}
                    />
                </MantineModal>

            </MantineContainer>
        </div>
    );
}
